// extracted by mini-css-extract-plugin
export default {"container-header":"BFEmailVerification_container-header__R3aoZ","container-body":"BFEmailVerification_container-body__Wnlk-"};